// extracted by mini-css-extract-plugin
module.exports = {"colorSample":"style_colorSample__3M-Mh","colorSampleTransparent":"style_colorSampleTransparent__3unus","colorSampleSquare":"style_colorSampleSquare__19oHg"};